/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListWebhookEndpointsRequest = {
  /**
   * An opaque cursor for pagination
   */
  cursor?: string | null | undefined;
  /**
   * The number of items per page (must be greater than 0 and less than or equal to 100)
   */
  pageSize?: number | undefined;
};

export type ListWebhookEndpointsResponse = {
  result: components.WebhookEndpointList;
};

/** @internal */
export const ListWebhookEndpointsRequest$inboundSchema: z.ZodType<
  ListWebhookEndpointsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  cursor: z.nullable(z.string()).optional(),
  page_size: z.number().int().default(10),
}).transform((v) => {
  return remap$(v, {
    "page_size": "pageSize",
  });
});
/** @internal */
export type ListWebhookEndpointsRequest$Outbound = {
  cursor?: string | null | undefined;
  page_size: number;
};

/** @internal */
export const ListWebhookEndpointsRequest$outboundSchema: z.ZodType<
  ListWebhookEndpointsRequest$Outbound,
  z.ZodTypeDef,
  ListWebhookEndpointsRequest
> = z.object({
  cursor: z.nullable(z.string()).optional(),
  pageSize: z.number().int().default(10),
}).transform((v) => {
  return remap$(v, {
    pageSize: "page_size",
  });
});

export function listWebhookEndpointsRequestToJSON(
  listWebhookEndpointsRequest: ListWebhookEndpointsRequest,
): string {
  return JSON.stringify(
    ListWebhookEndpointsRequest$outboundSchema.parse(
      listWebhookEndpointsRequest,
    ),
  );
}
export function listWebhookEndpointsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListWebhookEndpointsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListWebhookEndpointsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListWebhookEndpointsRequest' from JSON`,
  );
}

/** @internal */
export const ListWebhookEndpointsResponse$inboundSchema: z.ZodType<
  ListWebhookEndpointsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Result: components.WebhookEndpointList$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Result": "result",
  });
});
/** @internal */
export type ListWebhookEndpointsResponse$Outbound = {
  Result: components.WebhookEndpointList$Outbound;
};

/** @internal */
export const ListWebhookEndpointsResponse$outboundSchema: z.ZodType<
  ListWebhookEndpointsResponse$Outbound,
  z.ZodTypeDef,
  ListWebhookEndpointsResponse
> = z.object({
  result: components.WebhookEndpointList$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    result: "Result",
  });
});

export function listWebhookEndpointsResponseToJSON(
  listWebhookEndpointsResponse: ListWebhookEndpointsResponse,
): string {
  return JSON.stringify(
    ListWebhookEndpointsResponse$outboundSchema.parse(
      listWebhookEndpointsResponse,
    ),
  );
}
export function listWebhookEndpointsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListWebhookEndpointsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListWebhookEndpointsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListWebhookEndpointsResponse' from JSON`,
  );
}
